<template>
    <Head title="Customers"/>
    <list-page-template
        name="Customers"
        route="customers.index"
        :filters="filters" v-model:sort="currentSort" :sort-options="sortOptions" v-model:active-filters="activeFilters"
        description="Manage current customers">
        <h2 id="products-heading" class="sr-only">Customers</h2>
        <div class="flex flex-col">
            <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                        <table class="min-w-full divide-y divide-gray-200">
                            <thead class="bg-gray-50">
                            <tr>
                                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Phone Number</th>
                                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Email Address</th>
                                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                            </tr>
                            </thead>
                            <tbody class="bg-white divide-y divide-gray-200">
                            <tr v-for="customer in pagination.data" class="cursor-pointer" :key="customer.id">
                                <td class="px-6 py-4 whitespace-nowrap ">
                                    <div class="flex items-center">
                                        <div class="flex-shrink-0 h-10 w-10">
                                            <div v-if="!customer.photo" class="h-10 w-10 rounded-full overflow-hidden">
                                                <svg class="h-full w-full text-gray-300" fill="currentColor" viewBox="0 0 24 24">
                                                    <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
                                                </svg>
                                            </div>
                                            <img v-if="customer.photo" class="h-10 w-10 rounded-full object-cover" :src="customer.photo" alt="" />
                                        </div>
                                        <div class="ml-4">
                                            {{ customer.name }}
                                        </div>
                                    </div>
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap">
                                    <div class="text-sm text-gray-900">{{ getChannels(customer, 'phone-number') }}</div>
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap">
                                    <div class="text-sm text-gray-900">{{ getChannels(customer, 'email') }}</div>
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                    {{ customer.status }}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <pagination :pagination="this.pagination" />
    </list-page-template>
</template>

<script>
import Layout from '@/Shared/Layout'
import { isProxy, toRaw } from "vue"
import Pagination from '@/Shared/Pagination'
import { Head } from "@inertiajs/inertia-vue3";
import ListPageTemplate from "@/Shared/PageSegments/ListPageTemplate";

export default {
    layout: Layout,
    props: {
        auth: Object,
        sort: String,
        filters: Object,
        pagination: Object,
        sortOptions: Object,
        filterOptions: Object,
    },
    components: {
        Head,
        Pagination,
        ListPageTemplate,
    },
    data() {
        return {
            currentSort: this.sort ?? '',
            activeFilters: [],
        }
    },
    setup(props) {
        return {
            sortOptions: isProxy(props.sortOptions) ? toRaw(props.sortOptions) : props.sortOptions,
            filters: isProxy(props.filterOptions) ? toRaw(props.filterOptions) : props.filterOptions,
        }
    },
    methods: {
        getChannels(customer, delimiter) {
            if (!customer.channels) {
                return '-';
            }

            return customer.channels.filter(channel => channel.slug === delimiter).map(channel => {
                return channel.value;
            }).join(", ")
        },
    }
}
</script>
